// extracted by mini-css-extract-plugin
module.exports = {"EarnText":"EarnText_EarnText__OQBBT","TitleContainer":"EarnText_TitleContainer__BpoP0","Title":"EarnText_Title__QRhFw","InfoBtn":"EarnText_InfoBtn__Es0oo"};